import React, { useState, useEffect, useContext } from "react";
import styles from "../ImportTemplateList/ImportTemplateListModal.module.css"
import { getTemplatesFromDatabase } from "../../../hooks/Template";
import { TemplateContext } from '../../../context/TemplateContext';
import { useModal } from '../../../context/ModalContext';

function Modal({ closeModal }) {
  const { 
    setTemplate, 
    isEditedTemplate, 
    isDeletedTemplate, 
    clearSuccess
   } = useContext( TemplateContext );
  const [templates, setTemplates] = useState([]);

  const handleRowClick = ( template ) => {
    setTemplate(template);
};

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    const templateData = await getTemplatesFromDatabase();
    if (templateData) {
      setTemplates(templateData.data.templates);
    }
  };

  const { 
    openViewImportTemplateModal, 
    openEditImportTemplateModal, 
    openDeleteImportTemplateModal
   } = useModal();

  useEffect(() => {
    if (isEditedTemplate !== null) {
        if (isEditedTemplate) {
          alert("Template de importação de produtos editado com sucesso.")
            fetchTemplates();
        }
      clearSuccess();
    }
}, [isEditedTemplate]);

useEffect(() => {
  if (isDeletedTemplate !== null) {
      if (isDeletedTemplate) {
        alert("Template de importação de produtos excluído com sucesso.")
        fetchTemplates();
      }
    clearSuccess();
  }
}, [isDeletedTemplate]);

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        
        <div className={styles.content}>
          <h2>Lista de Templates</h2>
          <div className={styles.templateList}>
            {templates.map((template) => (
              <div 
              key={template.id} className={styles.templateItem}
              onClick={() => handleRowClick( template )}
              >
                <div>
                  <strong>ID:</strong> {template.id}
                </div>
                <div>
                  <strong>Nome do Template:</strong> {template.templateName}
                </div>
   
                <div className={styles.templateActions}>
                  <button className={styles.viewButton} onClick={ openViewImportTemplateModal }>Ver</button>
                  <button className={styles.editButton} onClick={ openEditImportTemplateModal }>Editar</button>
                  <button className={styles.deleteButton} onClick={ openDeleteImportTemplateModal }>Excluir</button>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.buttonContentContainer}>
          <div className={styles.buttonContent}>
            <button onClick={ closeModal } className={styles.buttonCancel}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Modal;
